//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class LibraryLendingLoanInputItem extends ItemBase {
    DueDate: string = "1970-01-01T00:00:00";
    LoanedByTeacherID: string | null = null;
    LoanedOn: string = "1970-01-01T00:00:00";
    StudentID: string | null = null;

    constructor(initializer?: Partial<LibraryLendingLoanInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "LibraryLendingLoanInputItem";
}
